<div class="flex flex-col gap-10 h-full">
    <!-- Todo: #CMS -->
    <p class="text-2xl/7 font-bold text-[#333333]">{{ cmsLabels.stellar.signIn.requestOtp.enterMobileNumber }}</p>
    <div class="flex flex-col gap-2 h-full">
        <form [formGroup]="phoneForm" class="h-full">
            <div class="flex flex-col justify-between h-full">
                <div class="flex flex-col h-full">
                    <!-- Todo: #CMS -->
                    <label class="text-xs font-medium text-[#737373]" for="phone-input">{{ cmsLabels.stellar.signIn.requestOtp.mobileNumber }}</label>
                    <div class="flex gap-2 border-solid border-[#B3B3B3] border-t-0 border-r-0 border-b-[1px] border-l-0 py-1">
                        <div #inputPhone class="relative">
                            <div (click)="toggleDropDown()" (keydown.enter)="toggleDropDown()" class="flex gap-1.5" tabindex=0>
                                <div>{{ phoneForm.get('iso2CountryCode')?.value }}</div>
                                <div>+{{ phoneForm.get('dialCountryCode')?.value }}</div>
                                <img
                                    src="assets/images/dropdown-chevron.svg"
                                    alt="MoneyGram Logo - Text"
                                />
                            </div>
                            <div *ngIf="isDropDownOpen" class="absolute left-0 shadow-md border border-solid border-gray-200 shadow-gray-100 rounded-lg overflow-hidden bg-white w-80 h-64">
                                <div class="overflow-y-auto h-full">
                                    <div *ngFor="let country of countryList; index as i" (click)="selectCountry(country)" (keydown.enter)="selectCountry(country)" class="h-[72px] flex items-center px-4 hover:bg-gray-100 focus:bg-gray-100" tabindex=0>
                                        {{ country.iso2Code }} +{{ country.countryDialingCode }} {{ country.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input [formControlName]="'phoneNumber'" class="border-none w-full text-base font-['Roboto'] text-[#333333] outline-none" id="phone-input" type="text" inputmode="numeric"/>
                    </div>
                </div>
                <!-- <div class="flex justify-center mb-4"> -->
                    <div id="recaptcha-container"></div>
                <!-- </div> -->
                <button id="request-otp-submit-button" type="submit" [disabled]="phoneForm.invalid || !isValidE164NumberFormat(phoneForm.get('internationalPhoneNumber')?.value)" (click)="requestOTP()" [ngClass]="{'sign-in-disabled-btn-filled': phoneForm.invalid || !isValidE164NumberFormat(phoneForm.get('internationalPhoneNumber')?.value), 'sign-in-red-btn-filled': phoneForm.valid}" class="mb-24">{{ cmsLabels.stellar.signIn.requestOtp.requestCode }}</button>
                <!-- Todo: #CMS -->
            </div>
        </form>
    </div>
</div>
